<template>
  <div class="form-group bg-light-2 p-4 shadow-lg mt-5">
    <h4>Caracteristicas</h4>
    <p>
      Escoger
      <b>cómo maximo diez</b> características que usarás para definir y explicar
      tu {{ kind }}.
    </p>
    <hr />
    <div class="row">
      <div v-for="(spec, i) in specs" :key="spec._id" class="col-md-3">
        <div class="form-group form-check">
          <input
            type="checkbox"
            class="form-check-input"
            :v-model="specs[i].cheked"
            @change="handleChangeSpecs($event, i)"
            :id="'spec-' + specs[i]._id"
          />
          <label class="form-check-label text-capitalize">{{
            spec.name
          }}</label>
        </div>
      </div>
      <div class="my-5" />
      <div
        v-for="(spec, i) in specs"
        :key="'s-' + spec._id"
        class="col-12"
        :class="specs[i].cheked ? '' : 'd-none'"
      >
        <div v-if="spec.selectable">
          <label class="font-weight-bold ml-1">{{ spec.name }}</label>
          <div class="form-inline">
            <div class="form-group mr-sm-3 mb-2">
              <input
                type="text"
                class="form-control"
                :placeholder="spec.name"
                v-model="specs[i].value"
                @keyup.enter="handleClickSpecOpt(i)"
              />
            </div>
            <span class="btn btn-treid mb-2 ml-2" @click="handleClickSpecOpt(i)"
              >+</span
            >
            <div
              class="mx-sm-3 mb-2"
              v-if="Object.keys(specs[i]).includes('options')"
            >
              <span
                class="badge badge-dark mr-1 p-2"
                v-for="(option, j) in specs[i].options"
                :key="`optionInSpec[${j}]`"
                >{{ option }}</span
              >
            </div>
            <span
              class="btn btn-warning ml-2 mb-2"
              @click="handleClearOptionSpec(i)"
              v-if="Object.keys(specs[i]).includes('options')"
              >Borrar opciones</span
            >
          </div>
        </div>
        <div class="form-group" v-else>
          <label class="font-weight-bold ml-1">{{ spec.name }}</label>
          <textarea
            type="text"
            class="form-control"
            :placeholder="spec.name"
            v-model="specs[i].value"
            @change="handleChangeValue(i)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../../tools/Api2";
export default {
  name: "SpecsPublication",
  props: {
    kind: {
      type: String,
      default: "producto",
    },
    productSpecs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      specs: [],
    };
  },
  created: function () {
    Api("form-category")
      .get()
      .then((res) => {
        this.specs = res.formCategories
          .filter((e) => {
            if(this.kind == "producto")
              return e.product
            return e.service
          })
          .map((e) => {
            e.value = "";
            e.options = [];
            let spec = this.productSpecs.find(
              (f) => f.form && f.form._id == e._id
            );
            if (spec) {
              e.cheked = true;
              if (e.selectable) {
                e.options = spec.options;
              } else {
                e.value = spec.value;
              }
            } else {
              e.cheked = false;
            }
            return {
              value: e.value,
              options: e.options,
              cheked: e.cheked,
              name: e.name,
              product: e.product,
              selectable: e.selectable,
              service: e.service,
              _id: e._id,
            };
          });
        this.$emit("initSpecs", this.specs);
      });
  },
  methods: {
    handleChangeValue(position) {
      this.$emit("handleChangeSpec", { position, spec: this.specs[position] });
    },
    handleChangeSpecs(e, position) {
      const checked = e.target.checked;
      // Verificamos que sean menos de 10 las seleccionadas
      const specsQuantity = this.specs.filter((spec) => spec.cheked).length;
      if (specsQuantity >= 10) return (this.specs[position].cheked = false);

      if (!checked) {
        this.specs[position].cheked = false;
        this.specs[position].options = [];
        this.specs[position].value = "";

        this.$emit("handleChangeSpec", {
          position,
          spec: {
            options: [],
            value: "",
            cheked: false,
          },
        });
        return;
      }

      this.specs[position].cheked = true;
      this.$emit("handleChangeSpec", {
        position,
        spec: {
          cheked: true,
        },
      });
    },
    handleClickSpecOpt(position) {
      // Inicializamos las opciones
      if (!this.specs[position].options) this.specs[position].options = [];

      // Verificamos si ya tiene esa opcion cargada
      let opt = this.specs[position].options.find((e) => e == this.specs.value);
      if (opt) return;

      this.specs[position].options.push(this.specs[position].value);
      this.specs[position].value = "";

      this.$emit("handleChangeSpec", {
        position,
        spec: this.specs[position],
      });
    },
    handleClearOptionSpec(position) {
      this.specs[position].options = [];
      this.$emit("handleChangeSpec", {
        position,
        spec: { options: [] },
      });
    },
  },
};
</script>